

/// <reference path="SalesAnnotation.ts" />

// Generated class SalesComponentAnnotation_ManagedObject

class SalesComponentAnnotation_ManagedObject extends SalesAnnotation
{
}
